import {combineReducers} from 'redux';

import globalReducer from './globalReducer';

const reducers = combineReducers({
    globalState: globalReducer,
});

export default reducers;
